// @flow
import { noop } from 'lodash/fp';
import instructions from '~/core/components/devices/offline/instructions';
import { getConfig, getFeatureFlag } from '~/core/state/config/selectors';
import { loadManageDevices } from '~/core/state/devices/actions';
import { getDeviceManufacturer } from '~/core/state/devices/selectors';
import { removableDevicesByManufacturers } from '~/core/constants/devices';

type StateProps = {
    deviceId: string,
    deviceInstructions: string,
    hiveHomeLink: string,
    hiveHomeLinkText: string,
    isRemovable: boolean,
    phoneNumber: string,
    placementGuideUrl: string
};

type DispatchProps = {
    refresh: noop
};

type InputProps = {
    type: string,
    deviceId: string
};

export const mapStateToProps = (state: any, { type, deviceId }: InputProps): StateProps => {
    const supportedTypes = getConfig(state, 'help:showDeviceOfflineNumberFor');
    const phoneNumber =
        (!supportedTypes || supportedTypes.includes(type)) && getConfig(state, 'help:deviceOfflineTelephoneNumber');
    const manufacturer = getDeviceManufacturer(state, { id: deviceId }) || '';
    const deviceInstructions = instructions[`${type}-${manufacturer}`] || instructions[type];
    const showPhoneNumber = getFeatureFlag(state, 'showPhoneNumber');

    return {
        deviceId,
        deviceInstructions,
        hiveHomeLink: getConfig(state, 'help:mainLink'),
        hiveHomeLinkText: getConfig(state, 'help:mainLinkText'),
        isRemovable: removableDevicesByManufacturers.includes(manufacturer),
        phoneNumber,
        placementGuideUrl: getConfig(state, 'help:hubPlacementGuide'),
        showPhoneNumber
    };
};

export const mapDispatchToProps: DispatchProps = {
    refresh: loadManageDevices
};



// WEBPACK FOOTER //
// ./src/core/components/widgets/device-offline/index.js